import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const NexusSelectionSkeleton = () => {
    return (
        <div className="max-w-2xl mx-auto space-y-4">
            {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="bg-gray-800/50 border border-gray-700 rounded-lg p-4 flex flex-col md:flex-row items-center justify-between">
                    <div className="w-full md:w-auto mb-4 md:mb-0 md:mr-4">
                        <SkeletonLoader className="h-6 w-40 mb-2" />
                        <SkeletonLoader className="h-4 w-full md:w-64" />
                    </div>
                    <SkeletonLoader className="h-10 w-full md:w-24" />
                </div>
            ))}
        </div>
    );
};

export default NexusSelectionSkeleton;
